import { combineReducers } from 'redux';
import {
  REQUEST_PASSWORD_RESET_SUCCESS,
  REQUEST_PASSWORD_RESET_REQUEST,
  REQUEST_PASSWORD_RESET_FAILED,
  RESET_PASSWORD_VALIDATE_TOKEN_REQUEST,
  RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS,
  RESET_PASSWORD_VALIDATE_TOKEN_FAILED,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_SUCCESS,
  RESET_PASSWORD_FAILED,
  RESET_PASSWORD_RESET_PROCESS,
} from '../actions';

function loading(state = false, action) {
  switch (action.type) {
    case RESET_PASSWORD_VALIDATE_TOKEN_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case REQUEST_PASSWORD_RESET_REQUEST:
      return true;
    case RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS:
    case RESET_PASSWORD_VALIDATE_TOKEN_FAILED:
    case RESET_PASSWORD_SUCCESS:
    case RESET_PASSWORD_FAILED:
    case RESET_PASSWORD_RESET_PROCESS:
    case REQUEST_PASSWORD_RESET_SUCCESS:
    case REQUEST_PASSWORD_RESET_FAILED:
      return false;
    default:
      return state;
  }
}

function isTokenValid(state = false, action) {
  switch (action.type) {
    case RESET_PASSWORD_VALIDATE_TOKEN_REQUEST:
    case RESET_PASSWORD_VALIDATE_TOKEN_FAILED:
    case RESET_PASSWORD_RESET_PROCESS:
      return false;
    case RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS:
      return true;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case RESET_PASSWORD_VALIDATE_TOKEN_REQUEST:
    case RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS:
    case RESET_PASSWORD_RESET_PROCESS:
      return null;
    case RESET_PASSWORD_VALIDATE_TOKEN_FAILED:
    case RESET_PASSWORD_FAILED:
    case REQUEST_PASSWORD_RESET_FAILED:
      return action.error;
    default:
      return state;
  }
}

function completed(state = false, action) {
  switch (action.type) {
    case RESET_PASSWORD_VALIDATE_TOKEN_REQUEST:
    case RESET_PASSWORD_RESET_PROCESS:
      return false;
    case RESET_PASSWORD_SUCCESS:
      return true;
    default:
      return state;
  }
}

function user(state = null, action) {
  switch (action.type) {
    case RESET_PASSWORD_VALIDATE_TOKEN_REQUEST:
    case RESET_PASSWORD_RESET_PROCESS:
      return null;
    case RESET_PASSWORD_VALIDATE_TOKEN_SUCCESS:
      return Object.assign({}, state, action.user);
    default:
      return Object.assign({}, state);
  }
}

function requested(state = false, action) {
  switch (action.type) {
    case REQUEST_PASSWORD_RESET_SUCCESS:
      return true;
    case RESET_PASSWORD_RESET_PROCESS:
    case REQUEST_PASSWORD_RESET_REQUEST:
    case REQUEST_PASSWORD_RESET_FAILED:
      return false;
    default:
      return state;
  }
}

const passwordReset = combineReducers({
  loading,
  isTokenValid,
  error,
  completed,
  user,
  requested,
});

export default passwordReset;
